// ======================================================================
// File Name       : LivePerformanceDetailRelationStatus
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment';
import LiveProgressDetailChart from '../LiveProgressDetailChart';
import TableHead from '../../components/TableHead';
import * as contentConstant from '../../constants/ContentConstant';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';
import * as userUtils from '../../utils/UserUtils';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import ReduxFormPaging from '../ReduxFormPaging';
import { percentLiveProgressRatio } from '../../utils/UsageSettingLiveUtils';

class LivePerformanceDetailRelationStatus extends React.Component {

  render() {
    const {
      liveDetailObj,
      recordNum,
      getStartEndData,
    } = this.props;
    const thead = [
      { title: '利用者名', sortBy: null },
      { title: 'ログインID', sortBy: null },
      { title: '参加状況', sortBy: null },
      { title: '滞在履歴', sortBy: null, width: 300 },
    ];
    return (
      <div>
        <Table striped hover>
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>
            {
            liveDetailObj && liveDetailObj.allSecernIds && liveDetailObj.allSecernIds.length > 0 && liveDetailObj.allSecernIds.map((liveSecernId, index) => {
              const bySecernId = liveDetailObj.bySecernId[liveSecernId];
              const {
                userName,
                loginId,
                liveProgressRatio,
                arrayDataSetsForChart,
              } = bySecernId;
              return (
                <tr key={index}>
                  <td>
                    {userName}
                  </td>
                  <td>
                    {loginId}
                  </td>
                  <td>
                    {percentLiveProgressRatio(liveProgressRatio)}
                  </td>
                  <td style={{ width: '100%' }}>
                    <LiveProgressDetailChart
                      arrayDataSetsForChart={arrayDataSetsForChart}
                      liveSecernId={liveSecernId}
                      index={index}
                    />
                  </td>
                </tr>
              );
            })
            }
          </tbody>
        </Table>
        <Col sm={12} className="text-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData.bind(this)}
          />
        </Col>
      </div>
    );
  }
}

export default LivePerformanceDetailRelationStatus;
